/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetHouseOfferHistoryByHouseIdRequest,
  TGetHouseOfferHistoryByHouseIdModel,
  IMappers,
  TGetHouseOfferHistoryByHouseIdResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOfferHistoryResponseDesktopV4 } from '../../entities/offer_history/OfferHistoryResponseDesktopV4';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHouseOfferHistoryByHouseIdModel(
  parameters: TGetHouseOfferHistoryByHouseIdRequest,
): TGetHouseOfferHistoryByHouseIdModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v1/get-house-offer-history-by-house-id/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetHouseOfferHistoryByHouseIdOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetHouseOfferHistoryByHouseIdRequest;
}

export async function fetchGetHouseOfferHistoryByHouseId<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseOfferHistoryByHouseIdOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHouseOfferHistoryByHouseIdResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseOfferHistoryByHouseIdModel(parameters),
    config,
  )) as FetchResponse<TGetHouseOfferHistoryByHouseIdResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferHistoryResponseDesktopV4, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHouseOfferHistoryByHouseIdResponse>;
}
